import { render, staticRenderFns } from "./department.children.list.panel.vue?vue&type=template&id=dff730e8&scoped=true&"
import script from "./department.children.list.panel.vue?vue&type=script&lang=js&"
export * from "./department.children.list.panel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dff730e8",
  null
  
)

export default component.exports